import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57717c3f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "skeleton-chart" }, null, -1))
const _hoisted_2 = {
  key: 2,
  class: "trade-table"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_skeleton_text = _resolveComponent("ion-skeleton-text")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_trade_select = _resolveComponent("trade-select")!
  const _component_trade_chart = _resolveComponent("trade-chart")!
  const _component_trade_popover = _resolveComponent("trade-popover")!
  const _component_trade_table = _resolveComponent("trade-table")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { "scroll-y": false }, {
        default: _withCtx(() => [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_1,
                (!_ctx.isMobile('mobile'))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(5, (i) => {
                      return _createVNode(_component_ion_item, {
                        key: i,
                        lines: "none"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_skeleton_text, { animated: "" })
                        ]),
                        _: 2
                      }, 1024)
                    }), 64))
                  : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_ctx.isMobile('mobile'))
                  ? (_openBlock(), _createBlock(_component_trade_select, { key: 0 }))
                  : _createCommentVNode("", true),
                _createVNode(_component_ion_item, {
                  class: "chart ion-no-padding",
                  lines: "none"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_trade_chart)
                  ]),
                  _: 1
                }),
                (_ctx.isMobile('mobile'))
                  ? (_openBlock(), _createBlock(_component_trade_popover, { key: 1 }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createVNode(_component_trade_table)
                    ]))
              ], 64))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}